import { createContext, type ReactNode, type RefObject } from 'react';

export type AppContextType = {
    sidebarRef: RefObject<HTMLDivElement> | null;
    showSidebar: (content: ReactNode, onClose?: () => void) => void;
    hideSidebar: () => void;
};

export const AppContext = createContext<AppContextType>({
    sidebarRef: null,
    showSidebar: () => {},
    hideSidebar: () => {},
});
